import { render } from "./BvWrapper.vue?vue&type=template&id=29eaead9"
import script from "./BvWrapper.vue?vue&type=script&lang=js"
export * from "./BvWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__